import withSplitting from 'components/hoc/withSplitting'
export default withSplitting(() => import('./LayoutHeaderMenu'), { componentName: 'organisms|LayoutHeaderMenu' })